var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"placeholder":"Number","min":"0","value":this.finding.questions.number.value,"hide-details":"","disabled":_vm.isNumberReadonly,"readonly":_vm.isNumberReadonly},on:{"change":_vm.handleNumberChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }